import React, { Component } from 'react';
import './AdminClientData.css';
import personlg from '../../../../image/personlg.svg'
class AdminClientData extends Component {
    render() {
        return (
            <div className="EditFAQ">
                
                <div className="row ">
                    
                    <div className="col-12">
                    
                        <p className="col-lg-8 mt-1 ml-1 px-2 fontsize10  "> <img className="iconsm mr-1" src={personlg} alt="user kayn" />

                            {this.props.state.objectClient.name}
                            
                        </p>
                        <div className="col-md-8 d-sm-flex justify-content-sm-between">
                            <p className="fontsize12 text-muted ">Member since May 12, 2019 </p>
                            <p className="fontsize12 text-muted ">Total orders: {this.props.state.objectClient.orders.length}</p>
                        </div>
                    </div>
                </div>
                <p className="col-md-6 mt-2 p-0 fontsize4 font-weight-bold ">Contact details</p>
                <hr />
                <div className=" my-4">
                    <p className="fontsize12 text-muted">Full Name</p>
                    <p  className="fontsize6 font-weight-bold text-dark" >{this.props.state.objectClient.name}</p>
                </div>
                <div className=" ">
                    <p  className="fontsize12 text-muted ">Phone number</p>
                    <p className="fontsize6 font-weight-bold  text-dark" >{this.props.state.objectClient.phone}</p>
                </div>
              
            </div>

        )
    }
}
export default AdminClientData;